import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { HeadingText } from '@paypalcorp/pp-react';
import { getDonateLocaleAPIFormat } from '../utilsV3/localeUtils.js';

const getRemainingTime = function (millis) {
  const remainingTimeOptions = { minute: '2-digit', second: '2-digit' };

  const remainingTime = new Date(0);
  remainingTime.setMilliseconds(millis);

  return remainingTime.toLocaleTimeString(
    getDonateLocaleAPIFormat(),
    remainingTimeOptions
  );
};

const CountdownTimer = (props) => {
  const { expireTime = 0, lastActivity = 0 } = props;

  const calculateRemainingTime = () => {
    return expireTime - (Date.now() - lastActivity);
  };

  const [timeLeft, setTimeLeft] = useState(calculateRemainingTime());

  useEffect(() => {
    if (timeLeft <= 0) {
      props.onTimeout(true);
      return;
    }
    if (timeLeft > 0) {
      if (props.pause) return;
      const intervalId = setInterval(() => {
        setTimeLeft(calculateRemainingTime());
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [timeLeft, props.pause]);

  return (
    <HeadingText className="countdown-timer-text" style={props.styles}>
      {getRemainingTime(timeLeft)}
    </HeadingText>
  );
};

CountdownTimer.propTypes = {
  expireTime: PropTypes.number,
  lastActivity: PropTypes.number,
  pause: PropTypes.bool,
  styles: PropTypes.object,
  onTimeout: PropTypes.func,
};

export default CountdownTimer;
